import React, { useContext, useEffect } from 'react'
import { makeStyles, Grid, Typography } from '@material-ui/core'
import { cloneDeep } from 'lodash'
import MarblesChart from '../components/MarblesChart/index'
import LastWeekStatsMobile from '../components/LastWeekStatsMobile'
import generateRiskCounts from '../ultils/generateRiskCounts'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { RISK_TYPE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  visArea: {
    flex: 1,
  },
  chartContainer: {
    backgroundColor: '#fff',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    padding: 16,
    boxSizing: 'border-box',
    marginBottom: 16,
  },
  legendWrapper: {
    width: '200px',
  },
  noDataContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '40px',
  },
  noDataText: {
    textAlign: 'center',
    width: '70%',
    fontSize: '0.7rem',
  },
})

const PortfolioLastWeekMobile = ({ tickers, riskType }) => {
  const classes = useStyles()

  const { state } = useContext(PortfolioContext)
  // TODO: replace these 2 lines in production!
  // const LAST_WEEK = new Date('2021-02-26T03:24:00')
  const LAST_WEEK = new Date(new Date().setDate(new Date().getDate() - 7))

  const [increasingRiskTickers, decreasingRiskTickers] = cloneDeep(
    tickers,
  ).reduce(
    (acc, curr) => {
      const [inc, dec] = acc
      const changeValue =
        riskType === RISK_TYPE.CREDIT
          ? curr.output_credit_change
          : curr.output_change
      if (changeValue < 0 && curr.date > LAST_WEEK) {
        return [[...inc, curr], dec]
      }
      if (changeValue > 0 && curr.date > LAST_WEEK) {
        return [inc, [...dec, curr]]
      }
      return acc
    },
    [[], []],
  )

  return (
    <Grid container>
      {[
        {
          tickers: increasingRiskTickers,
          title: 'Last Week Higher Level of Risk',
        },
        {
          tickers: decreasingRiskTickers,
          title: 'Last Week Lower Level of Risk',
        },
      ].map(({ tickers, title }, i) => (
        <Grid item xs={12} md={6} key={i}>
          <div className={classes.chartContainer}>
            <LastWeekStatsMobile
              data={generateRiskCounts(tickers, riskType).filter(
                cat => cat.count > 0,
              )}
              total={tickers.length}
              title={title}
            />
            <div className={classes.visArea}>
              {tickers.length === 0 ? (
                <div className={classes.noDataContainer}>
                  <Typography className={classes.noDataText}>
                    There is no change in risk status of any portfolio company,
                    looking back over the last seven days
                  </Typography>
                </div>
              ) : (
                <MarblesChart
                  isEmptyData={state.tickersInPortfolio.length === 0}
                  tickers={tickers}
                  group="none"
                  riskType={riskType}
                />
              )}
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  )
}

export default PortfolioLastWeekMobile
